module.exports = __webpack_public_path__ + "img/product2.994248e0.png";